import { Route } from '@angular/router';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { InitialDataResolver } from './app.resolvers';

// @formatter:off
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboard'
    { path: '', pathMatch: 'full', redirectTo: 'projects' },

    // Redirect signed in user to the '/dashboard'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'projects' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-in', loadChildren: () => import('../app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) },
        ]
    },

    // Routes for authenticated users and guest
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'forgottenPassword', loadChildren: () => import('../app/modules/auth/reset-password/reset-password.module').then(m => m.ResetPasswordModule) },
            { path: 'audit', loadChildren: () => import('../app/modules/staffhotel/audit/audit.module').then(m => m.AuditModule) },
            { path: 'qrmail', loadComponent: () => import('../app/modules/nextstaff/qrform/qrform.component').then(m => m.QRFormComponent) },
            { path: 'hotel-work-audit', loadComponent: () => import('../app/modules/staffhotel/hotel-work-audit/hotel-work-audit.component').then (c => c.HotelWorkAuditComponent) },
            { path: 'monthly-work', loadComponent: () => import('../app/modules/staffhotel/monthly-work/monthly-work.component').then(c => c.MonthlyWorkComponent) }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('../app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule) },
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            { path: 'dashboard', loadChildren: () => import('../app/modules/admin/dashboard/dashboard.module').then(m => m.DashboardModule) },
            { path: 'connected-device', loadChildren: () => import('../app/modules/admin/connected-device/connected-device.module').then(m => m.ConnectedDeviceModule) },
            { path: 'mission-users', loadChildren: () => import('../app/modules/admin/mission-users/mission-users.module').then(m => m.MissionUsersModule) },
            { path: ':marca_code/brand-tasks', loadChildren: () => import('../app/modules/admin/global-tasks/tasks.module').then(m => m.TasksModule) },
            { path: ':marca_code/:cliente_code/customer-tasks', loadChildren: () => import('../app/modules/admin/global-tasks/tasks.module').then(m => m.TasksModule) },
            { path: 'projects', loadChildren: () => import('../app/modules/admin/projects/projects.module').then(m => m.ProjectsModule) },
            { path: ':projectId/services', loadChildren: () => import('../app/modules/admin/services/services.module').then(m => m.ServicesModule) },
            { path: ':projectId/project-tasks', loadChildren: () => import('../app/modules/admin/global-tasks/tasks.module').then(m => m.TasksModule) },
            { path: 'ou', loadChildren: () => import('../app/modules/admin/ou/ou.module').then(m => m.OUModule) },
            { path: ':serviceId/tasks', loadChildren: () => import('../app/modules/admin/tasks/tasks.module').then(m => m.TasksModule) },
            { path: ':serviceId/workshifts', loadChildren: () => import('../app/modules/admin/workshifts/workshifts.routes').then(r => r.routes) },
            { path: ':serviceId/forms', loadChildren: () => import('../app/modules/admin/service-forms/service-forms.module').then(m => m.ServiceFormsModule) },
            { path: ':serviceId/housekeeping', loadChildren: () => import('../app/modules/admin/housekeeping/housekeeping.routes').then(r => r.routes) },
            { path: ':serviceId/center', loadChildren: () => import('../app/modules/admin/center/center.routes').then(r => r.routes) },
            { path: ':serviceId/generic', loadChildren: () => import('../app/modules/admin/task-list/task-list.routes').then(r => r.routes) }
        ]
    },

    // Error routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: '403', loadChildren: () => import('../app/modules/error/error-403/error-403.module').then(m => m.Error403Module) },
            { path: '404', loadChildren: () => import('../app/modules/error/error-404/error-404.module').then(m => m.Error404Module) },
            { path: '500', loadChildren: () => import('../app/modules/error/error-500/error-500.module').then(m => m.Error500Module) },
            { path: '**', redirectTo: '/404' }
        ]
    }
];
